import { Badge } from '@ophelos/ui/components/badge';
import { Card, CardAction, CardContent, CardHeader, CardTitle } from '@ophelos/ui/components/card-layer';
import type { DebtData } from '@/types';
import { DebtButton } from './DebtButton';

interface DebtGroupProps {
  title: string;
  badgeLabel: string;
  badgeVariant?: 'default' | 'success' | 'failure' | 'outline' | 'subtle' | 'warning' | 'info';
  debts: DebtData[];
  state: 'unpaid' | 'in-progress' | 'completed';
  onDebtClick: (debt: DebtData) => void;
  showProgress?: boolean;
  pendingCaseIds?: readonly string[] | null;
}

export function DebtGroup({ title, badgeLabel, badgeVariant = 'default', debts, state, onDebtClick, pendingCaseIds }: DebtGroupProps) {
  if (debts.length === 0) return null;

  const isCompleted = state === 'completed';

  return (
    <Card className={`gap-2 overflow-visible mt-5 ${isCompleted ? 'bg-soft' : ''}`} variant="fullscreen">
      <CardHeader className="h-full ">
        <CardTitle className="tracking-wide">{title}</CardTitle>
        <CardAction>
          <Badge variant={badgeVariant}>{badgeLabel}</Badge>
        </CardAction>
      </CardHeader>
      {debts.map((debt) => (
        <CardContent key={debt.id} className="py-0 px-0 rounded-2xl border-none">
          <DebtButton debt={debt} onClick={onDebtClick} pending={pendingCaseIds?.includes(debt.id) ?? false} />
        </CardContent>
      ))}
    </Card>
  );
}
